import type React from 'react'
import type { TextBoxColors } from 'atoms/TextBox'
import type { ContainerHeaderPaddings } from '../ContainerHeader.h'

import { TextBox, TextBoxTypes, TextTransform } from 'atoms/TextBox'
import { ContainerHeader } from '../ContainerHeader'
import {
  ContainerHeaderAlignItems,
  ContainerHeaderJustifyContent,
} from '../ContainerHeader.h'

export interface IContainerHeaderWithTitleOnlyProps {
  title: string
  paddings?: (typeof ContainerHeaderPaddings)[keyof typeof ContainerHeaderPaddings]
  children?: React.ReactNode | null
  color?: TextBoxColors
}

export const ContainerHeaderWithTitleOnly = ({
  title,
  paddings,
  children,
  color,
}: IContainerHeaderWithTitleOnlyProps) => (
  <ContainerHeader
    alignItems={ContainerHeaderAlignItems.Baseline}
    justifyContent={ContainerHeaderJustifyContent.SpaceBetween}
    paddings={paddings}
  >
    <TextBox
      title={title}
      font={TextBoxTypes.Headline3}
      textTransform={TextTransform.None}
      color={color}
    />
    {children}
  </ContainerHeader>
)

ContainerHeaderWithTitleOnly.displayName = 'ContainerHeaderWithTitleOnly'
